<template>
  <div id="sig-container" class="full form-horizontal">
    <contacto />
    <div class="widget">
      <div
        class="
          widget-content widget-content-mini
          themed-background-dark-default
          text-light
        "
      >
        <span class="float-right text-muted"></span>
        Detalles de la obligación
      </div>
      <div
        class="widget-content border-bottom themed-background-muted text-center"
        v-if="detalle_obligaciones"
      >
        <div
          class="row mt-2"
          v-for="detalle_obligacion of detalle_obligaciones"
          v-bind:key="detalle_obligacion.label"
        >
          <div class="col-md-4 text-right ajustarTexto">
            <strong>{{ detalle_obligacion.label | capitalize }}:</strong>
          </div>
          <div
            class="col-md-8 text-left ajustarTexto"
            :style="detalle_obligacion.style"
          >
            <span v-if="detalle_obligacion.pipe == 'numberFormat'">{{
              detalle_obligacion.value | numberFormat
            }}</span>
            <span v-else-if="detalle_obligacion.pipe == 'percentage'">{{
              detalle_obligacion.value | percentage
            }}</span>
            <span v-else-if="detalle_obligacion.pipe == 'numeric'">{{
              detalle_obligacion.value | numeric
            }}</span>
            <span v-else-if="detalle_obligacion.pipe == 'capitalize'">{{
              detalle_obligacion.value | capitalize
            }}</span>
            <span v-else-if="detalle_obligacion.pipe == 'dates'">{{
              detalle_obligacion.value | dates
            }}</span>
            <span v-else>{{ detalle_obligacion.value }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="widget">
      <div
        class="
          widget-content widget-content-mini
          themed-background-dark-default
          text-light
        "
      >
        <span class="float-right text-muted"></span>
        Detalles de abonos
        <button
          @click="exportarPDF()"
          :disabled="abonos.length == 0 || this.loading_response"
          class="btn float-right btn-sm btn-primary py-0"
        >
          Exportar PDF
        </button>
      </div>
      <div
        class="widget-content border-bottom themed-background-muted text-center"
      >
        <template v-if="abonos.length > 0">
          <table-component :data="abonos">
            <table-column
              slot="label"
              :label="'Codigo'"
              v-bind:value="'codigo'"
            ></table-column>
            <table-column
              slot="label"
              :label="'Tipo'"
              v-bind:value="'tipo'"
            ></table-column>
            <table-column
              slot="label"
              :label="'Fecha del abono'"
              v-bind:value="'fecha'"
            ></table-column>
            <table-column
              slot="label"
              :label="'Valor'"
              v-bind:value="'valor'"
              :filter="'numberFormat'"
            ></table-column>
          </table-component>
          <div class="row lead">
            <div class="col text-center">
              <b>Total abonado: {{ total_abonos | numberFormat }}</b>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="content text-center">
            <h3>No se encontraron abonos para esta obligación</h3>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import FileSaver from "file-saver";

export default {
  name: "Obligación",
  data: () => {
    return {
      presentacion_de_datos: [],
      total_abonos: 0,
      loading_response: false,
    };
  },
  components: {
    Contacto: () => import("@/views/Contacto.vue"),
    TableComponent: () => import("@@/components/table/TableComponent"),
    TableColumn: () => import("@@/components/table/TableColumn"),
  },
  computed: {
    ...mapGetters({
      deudor: "deudor/deudor",
      loading: "loading",
      obligaciones: "deudor/obligaciones",
      abonos: "abonos/abonos",
    }),
    detalle_obligaciones() {
      const obligacion = this.obligaciones.find(
        (obligacion) => obligacion.id == this.$route.params.obligacion_id
      );

      let info = JSON.parse(JSON.stringify(obligacion.informacion_adicional));

      let info_ordenada = [];
      let primeros = [];

      if (obligacion) {
        // Ordenados primero
        primeros.push({ field: "nombre_banco", pipe: "capitalize" });
        primeros.push({ field: "pagare" });
        primeros.push({
          label: "Total pagado a capital",
          field: "pagado_capital",
          pipe: "numberFormat",
          style: "font-weight: bold;",
        });
        primeros.push({
          label: "Total pagado a Intereses intermediario",
          field: "pagado_intereses_intermedirario",
          pipe: "numberFormat",
          style: "font-weight: bold;",
        });
        primeros.push({
          label: "Total pagado a otros gastos",
          field: "pagado_otros_gastos",
          pipe: "numberFormat",
          style: "font-weight: bold;",
        });
        primeros.push({
          label: "Total pagado",
          field: "pagado_total",
          pipe: "numberFormat",
          style: "font-weight: bold;",
        });
        primeros.push({
          label: "Adiciones",
          field: "adiciones",
          pipe: "numberFormat",
          style: "font-weight: bold;",
        });
        primeros.push({ field: "fecha_desembolso" });
        primeros.push({
          label: "Saldo capital",
          field: "saldo_capital",
          pipe: "numberFormat",
        });
        primeros.push({
          label: "Saldo capital",
          field: "saldo_capital",
          pipe: "numberFormat",
        });
        primeros.push({
          label: "Saldo intereses intermediario",
          field: "saldo_intereses_intermediario",
          pipe: "numberFormat",
        });
        primeros.push({
          label: "Saldo otros gastos",
          field: "saldo_otros_gastos",
          pipe: "numberFormat",
        });
        primeros.push({
          label: "Saldo otros gastos",
          field: "saldo_otros_gastos",
          pipe: "numberFormat",
        });

        // Eliminamos lo que no queremos ver
        delete info["generar_paz_salvo"];
        // delete info["adiciones"];
        // delete info["saldo_otros_fga"];
        // delete info["saldo_capital"];
        // delete info["saldo_intereses_intermediario"];
        // delete info["saldo_otros_gastos"];
        delete info["sig_convenio_id"];
        delete info["sig_producto_id"];
        delete info["vendida"];

        primeros.forEach((element) => {
          if (info.hasOwnProperty(element.field)) {
            info_ordenada.push({
              label:
                element.label != undefined
                  ? element.label
                  : element.field.replace(/_/g, " "),
              pipe: element.pipe,
              value: info[element.field],
              style: element.style != undefined ? element.style : null,
            });
            delete info[element.field];
          }
        });

        Object.keys(info).forEach((element) => {
          if(element == "riesgo_operacional"){
            info_ordenada.push({
              label: element.replace(/_/g, " "),
              pipe: "",
              value: info[element] ? "Si" : "No",
            });
          }else{
            info_ordenada.push({
              label: element.replace(/_/g, " "),
              pipe: "",
              value: info[element],
            });
          }
          delete info[element];
        });
      }

      return info_ordenada;
    },
  },
  methods: {
    getAbonos(obligacion_id) {
      this.$store
        .dispatch("index", {
          endpoint: "abono",
          params: { obligacion_id: obligacion_id, paginar: false },
        })
        .then((response) => {
          if (response.datos.length > 0) {
            this.total_abonos = response.datos.reduce((a, b) => {
              return a + b.valor;
            }, 0);

            this.$store.dispatch("abonos/refresh_abonos", response.datos);
          } else {
            this.$notify({
              title: "Advertencia!",
              type: "warning",
              content: "No se encontraron abonos",
            });

            this.$store.dispatch("abonos/refresh_abonos", response.datos);
          }
        })
        .catch(() => {
          this.$notify({
            title: "Advertencia!",
            type: "danger",
            content: "Se ha presentado un error realizando su consulta",
          });
        });
    },
    exportarPDF() {
      this.loading_response = true;
      this.$store
        .dispatch("store", {
          endpoint: "utilidades/generar-documento-abonos",
          params: this.abonos,
          config: {
            responseType: "arraybuffer",
          },
        })
        .then((response) => {
          var blob = new Blob([response], {
            type: "application/pdf;charset=utf-8",
          });
          FileSaver.saveAs(
            blob,
            "Abonos_" + this.abonos[0]["obligacion_id"] + ".pdf"
          );
          this.$notify({
            title: "Histórico Abonos",
            type: "success",
            content: "La descarga se completó con éxito",
          });
          this.loading_response = false;
        })
        .catch((error) => {
          this.loading_response = false;
          this.$notify({
            title: "Histórico Abonos",
            type: "warning",
            content: "Los datos dados no son válidos",
          });
        });
    },
  },
  mounted() {
    this.getAbonos(this.$route.params.obligacion_id);
  },
};
</script>
<style>
@media (max-width: 768px) {
  .ajustarTexto {
    text-align: left !important;
  }
}
</style>